// Sai maheshwar 01/04/2023 2701334326 Add Record Group
// kavyareddy 01/10/2023 2701334326 Integrated download print api
// Dilip 01/11/2023 2701334326 Integrated system notes api
// Sohel 01/12/2023 2699299906 set isDraft Status
// Sohel 01/12/2023 2699299906 changed Download Configuration Url
// Sohel 01/24/2023 2789725780 category fields
// Sohel 01/08/2023 2701335619 implemented Usage Functionality
// Akhila 02/24/2023 2701335619 implemented preview file functionality in download configuration
// Ravi 06/23/2023 2701335619 fixed submit issue
import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {fetchDownloadSuccess} from '../PreviewFileData';
import {submissionEnd} from '../CommonActions/commonActions';

const initialState = {
  isLoading: false,
  successMsg: null,
  errorMsg: null,
  addBasicInfoStatus: null,
  basicInfoData: {},
  recordType: {},
  mapRecordData: {},
  addMapRecordStatus: null,
  fixedLength: '',
  allRecordGroupCode: [],
  groupCode: 0,
  dmRecordGroupId: 0,
  masterRecord: null,
  addSystemNotesStatus: null,
  notesSuccessMsg: null,
  isDraftRecordGroup: null,
  lastStep: 0,
  addPreprocessorGroupStatus: null,
  processorGroupData: {},
  categoryRecordGroup: {},
  dataManagerRecordGroupUsage: {},
  configurationUrl: '',
  dockey: '',
};

const dataManagerRecordGroup = createSlice({
  name: 'dataManagerRecordGroup',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.isLoading = false;
      state.errorMsg = action.payload;
    },
    postBasicInfoData: (state, action) => {
      state.isLoading = false;
      state.successMsg = action.payload.message;
      state.addBasicInfoStatus = action.payload.status;
      state.errorMsg = null;
      state.groupCode = action.payload.response.groupCode;
      state.dmRecordGroupId = action.payload.response.dmRecordGroupId;
    },
    postAddProcessorGroupData: (state, action) => {
      state.isLoading = false;
      state.successMsg = action.payload.message;
      state.addPreprocessorGroupStatus = action.payload.status;
      state.errorMsg = null;
      state.groupCode = action.payload.response.recordGroupCode;
    },
    postSystemNotesData: (state, action) => {
      state.addSystemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.notesSuccessMsg = action.payload.message;
    },
    resetSystemNotesData: (state) => {
      state.isLoading = false;
      state.addSystemNotesStatus = null;
      state.notesSuccessMsg = null;
      state.errorMsg = null;
    },
    postCopyData: (state, action) => {
      state.isLoading = false;
      state.successMsg = action.payload.message;
      state.addBasicInfoStatus = action.payload.status;
      state.errorMsg = null;
      state.groupCode = action.payload.response.groupCode;
      state.dmRecordGroupId = action.payload?.response?.dmRecordGroupId;
    },
    setRecordGroupResponse: (state, action) => {
      state.isLoading = false;
      state.successMsg = action.payload.message;
      state.errorMsg = null;
    },
    setRecordGroupRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setIsDraftRecordGroup: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setFixedLengthRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setLastStepRecordGroupRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setCategoryRecordGroupRedux: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    getBasicInfoData: (state, action) => {
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
      state.addBasicInfoStatus = null;
      state.basicInfoData = action.payload;
    },
    getDataManagerRecordGroupUsageData: (state, action) => {
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
      state.dataManagerRecordGroupUsage = action.payload;
    },
    resetDataManagerRecordGroupUsageData: (state) => {
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
      state.dataManagerRecordGroupUsage = {};
    },
    getProcessorGroupData: (state, action) => {
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
      state.addPreprocessorGroupStatus = null;
      state.processorGroupData = action.payload;
    },
    setGroupCode: (state, action) => {
      state.groupCode = action.payload;
    },
    setdmRecordGroupId: (state, action) => {
      state.dmRecordGroupId = action.payload;
    },
    getAllRecordGroupCode: (state, action) => {
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
      state.allRecordGroupCode = action.payload;
    },
    setRecordGroupGetResponse: (state, action) => {
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
      state.addMapRecordStatus = null;
      state.mapRecordData = action.payload;
    },
    getPrintDataGroup: (state, action) => {
      state.isLoading = false;
      state.successMsg = action.payload.response;
      state.errorMsg = null;
    },
    setRecordGroupPostResponse: (state, action) => {
      state.isLoading = false;
      state.successMsg = action.payload.message;
      state.errorMsg = null;
      state.addMapRecordStatus = action.payload.status;
    },
    resetBasicInfoData: (state) => {
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
      state.addBasicInfoStatus = null;
    },
    resetMapRecordData: (state) => {
      state.isLoading = false;
      state.successMsg = false;
      state.errorMsg = null;
      state.addMapRecordStatus = null;
    },
    resetDataManagerRecordGroupData: (state) => {
      state.basicInfoData = {};
      state.groupCode = 0;
      state.mapRecordData = {};
      state.successMsg = false;
      state.processorGroupData = {};
      state.dmRecordGroupId = 0;
    },
    resetAddProcessorGroupData: (state) => {
      state.isLoading = null;
      state.successMsg = null;
      state.errorMsg = null;
      state.addPreprocessorGroupStatus = null;
    },
    resetBasicInfoRecordGroupData: (state) => {
      state.basicInfoData = {};
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
  },
});

export default dataManagerRecordGroup.reducer;
export const {
  fetchStart,
  fetchError,
  postBasicInfoData,
  getBasicInfoData,
  resetBasicInfoData,
  resetDataManagerRecordGroupData,
  setRecordGroupPostResponse,
  setRecordGroupGetResponse,
  setRecordGroupRedux,
  resetMapRecordData,
  setFixedLengthRedux,
  getAllRecordGroupCode,
  setGroupCode,
  setdmRecordGroupId,
  getPrintDataGroup,
  postCopyData,
  postSystemNotesData,
  resetSystemNotesData,
  setIsDraftRecordGroup,
  resetBasicInfoRecordGroupData,
  setLastStepRecordGroupRedux,
  postAddProcessorGroupData,
  resetAddProcessorGroupData,
  getProcessorGroupData,
  setCategoryRecordGroupRedux,
  getDataManagerRecordGroupUsageData,
  resetDataManagerRecordGroupUsageData,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
} = dataManagerRecordGroup.actions;

export const postBasicInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`record/group/save`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postBasicInfoData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postRecordGroupCopy = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`record/group/copy/recordgroup`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postCopyData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postAddProcessorGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`record/group/save/preprocessorgroup`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postAddProcessorGroupData(data));
          dispatch(fetchPreprocessorGroupData(data.response?.recordGroupId));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchBasicInfoData = (dmRecordGroupId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`record/group/get/${dmRecordGroupId}`)
      .then((data) => {
        dispatch(setdmRecordGroupId(dmRecordGroupId))
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(setGroupCode(data?.response?.groupCode));
          dispatch(getBasicInfoData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchDataManagerRecordGroupUsage = (type, recordCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dm/get/dmrecordgroup/usage/${type}/${recordCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getDataManagerRecordGroupUsageData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const fetchPreprocessorGroupData = (recordCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`record/group/get/preprocessorgroup/${recordCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getProcessorGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAllRecordGroupCode = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`record/group/get/allcode/${type}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getAllRecordGroupCode(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postRecordGroup = (payload) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`record/group/save/recordGroupMap`, payload)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(setRecordGroupPostResponse(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchRecordGroupData = (recordCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`record/group/get/recordGroupMap/${recordCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(setRecordGroupGetResponse(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postPrintImportRecordGroup = (data, type) => {
  const url =
    type === 'Export' ?
      'record/group/print/exportManagergroup' :
      'record/group/print/importrecordgroup';
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(url, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(printImportMasterGroup({dockey: data?.message}, data, type));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const printImportMasterGroup = (payload, postdata, type) => {
  const url =
    type === 'Export' ?
      'record/group/generateurlexportmanagergroupprint' :
      'record/group/generateimportrecordgroupprinturl';
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(url, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(getPrintDataGroup(postdata));
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccess(postdata));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postSystemNotes = (details, type) => {
  const url =
    type === 'Export' ?
      `record/group/save/exportrecordgroupnotes` :
      `record/group/save/importrecordgroupnotes`;
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(url, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetDataManagerRecordGroupUsage = () => {
  return (dispatch) => {
    dispatch(resetDataManagerRecordGroupUsageData());
  };
};
export const resetBasicInfo = () => {
  return (dispatch) => {
    dispatch(resetBasicInfoData());
  };
};

export const resetMapRecord = () => {
  return (dispatch) => {
    dispatch(resetMapRecordData());
  };
};

export const resetAddProcessorGroup = () => {
  return (dispatch) => {
    dispatch(resetAddProcessorGroupData());
  };
};
export const resetDataManagerRecordGroup = () => {
  return (dispatch) => {
    dispatch(resetDataManagerRecordGroupData());
  };
};
export const resetSystemNotes = () => {
  return (dispatch) => {
    dispatch(resetSystemNotesData());
  };
};
export const resetBasicInfoRecordGroup = () => {
  return (dispatch) => {
    dispatch(resetBasicInfoRecordGroupData());
  };
};
